import { render } from "./PurchaseWaitingView.vue?vue&type=template&id=eda4b58c"
import script from "./PurchaseWaitingView.vue?vue&type=script&lang=js"
export * from "./PurchaseWaitingView.vue?vue&type=script&lang=js"

import "./PurchaseWaitingView.vue?vue&type=style&index=0&id=eda4b58c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__